export const urls = {
  GET_KUPCI: 'Kupci/vrati_kupce',
  INSERT_KUPAC: 'Kupci/unos_kupca',
  UPDATE_KUPAC: 'Kupci/izmena_kupca',
  DELETE_KUPAC: 'Kupci/brisanje_kupca',
};
